<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="160" height="20" viewBox="0 0 160 20" fill="none">
    <ellipse opacity="0.05" cx="80" cy="10" rx="80" ry="10" class="white-fill" />
  </svg>
</template>

<style lang="scss" scoped>
.white-fill {
  fill: #131a28;
}
.dark {
  .white-fill {
    fill: #ffffff;
  }
}
</style>
